import React from "react";
import { Props } from "./interfaces";
import OutgoingMailCard from "./OutgoingMailCard/OutgoingMailCard";
import OutgoingMailCardTest from "./OutgoingMailCard/OutgoingMailCard-test";

import { Grid } from "@mui/material";

const ManageOutgoingMailsList = ({ items, handleNotifyParent, canUpload, canClassify, canRead, canProcess }: Props) => {
  return (
    <Grid>
      {items.map((item, idx) => (
        <OutgoingMailCard
          key={idx}
          outgoingMail={item}
          handleNotifyParent={handleNotifyParent}
          canUpload={canUpload}
          canClassify={canClassify}
          canRead={canRead}
          canProcess={canProcess}
        />
      ))}
      {/* <OutgoingMailCardTest /> */}
    </Grid>
  );
};

export default ManageOutgoingMailsList;
